var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7391 1.17232C18.3062 0.757585 17.727 0.530708 17.1276 0.541114C16.5283 0.55152 15.9573 0.798366 15.5391 1.22787L12.6724 4.1001C12.3574 4.41362 11.9344 4.59465 11.4901 4.60602C11.0459 4.61738 10.6141 4.45822 10.2835 4.16121L9.49463 4.9501L15.0002 10.439L15.7891 9.6501C15.4818 9.31923 15.3129 8.88328 15.3171 8.43179C15.3212 7.98029 15.4981 7.54751 15.8113 7.22232L18.6835 4.3501C19.1077 3.93352 19.3512 3.36699 19.3616 2.77258C19.372 2.17816 19.1484 1.60346 18.7391 1.17232Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3158 9.03876L5.22366 16.1841C5.13584 16.2814 5.02931 16.3597 4.91054 16.4143C4.79178 16.4689 4.66324 16.4986 4.53274 16.5016C4.40224 16.5046 4.2725 16.4808 4.15138 16.4318C4.03027 16.3827 3.9203 16.3094 3.82816 16.2162C3.73603 16.1231 3.66364 16.012 3.61538 15.8898C3.56713 15.7676 3.54403 15.6368 3.54747 15.5054C3.55091 15.3739 3.58083 15.2445 3.63541 15.1251C3.68998 15.0056 3.76808 14.8985 3.86497 14.8104L10.9523 7.68444L10.273 7L3.18081 14.126C2.88056 14.4247 2.6859 14.8144 2.62672 15.2353C2.56753 15.6562 2.64709 16.085 2.85318 16.456L2.14011 17.1744C2.05037 17.2654 2 17.3884 2 17.5166C2 17.6449 2.05037 17.7679 2.14011 17.8588C2.23038 17.9493 2.35249 18 2.47978 18C2.60706 18 2.72918 17.9493 2.81945 17.8588L3.51325 17.1598C3.81504 17.3504 4.16406 17.4514 4.52022 17.4511C4.77821 17.451 5.03363 17.3995 5.27178 17.2995C5.50992 17.1995 5.72609 17.0531 5.90782 16.8686L13 9.72806L12.3158 9.03876Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorFill);
export default __webpack_public_path__ + "static/media/ColorFill.30cd931e6d8fd0371401540ee3e09fbf.svg";
export { ForwardRef as ReactComponent };